import React from 'react'

import { ButtonClean, Fieldset, InputUI, useModalContext } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import { SelectMembers } from '../../../SelectMembers/SelectMembers'
import type { FormValues } from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { SelectedMember } from '../SelectedMember'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
}

export const SelectedMembers = ({ form }: Props) => {
  const modal = useModalContext()

  const renderMembersList = () => {
    if (!form.values.giveToSelectedMembers) return null
    if (!form.values.manuallyAssignedSupporters.length) return null

    return (
      <Fieldset.Row inner>
        <div style={{ width: '100%' }}>
          {form.values.manuallyAssignedSupporters.map((member) => {
            return (
              <SelectedMember
                key={member.id}
                avatarUrl={member.avatarUrl}
                nickname={member.nickname}
                onRemove={() => {
                  form.setFieldValue(
                    FormFields.manuallyAssignedSupporters,
                    form.values.manuallyAssignedSupporters.filter(
                      (supporter) => supporter.id !== member.id,
                    ),
                  )
                }}
              />
            )
          })}
        </div>
      </Fieldset.Row>
    )
  }

  const renderAddMembersButton = () => {
    if (!form.values.giveToSelectedMembers) return null

    return (
      <Fieldset.Row inner>
        <ButtonClean
          label="Add or remove members"
          onClick={() =>
            modal.open(SelectMembers, {
              selectedMembers: form.values.manuallyAssignedSupporters.map((member) => ({
                id: member.id,
                nickname: member.nickname,
                avatarUrl: member.avatarUrl,
              })),
              onSave: (selectedMembers) => {
                form.setFieldValue(FormFields.manuallyAssignedSupporters, selectedMembers)
              },
            })
          }
        />
      </Fieldset.Row>
    )
  }

  return (
    <>
      {renderMembersList()}
      {renderAddMembersButton()}
      {form.errors.manuallyAssignedSupporters &&
        typeof form.errors.manuallyAssignedSupporters === 'string' && (
          <Fieldset.Row inner>
            <InputUI.Error $withoutMargin>{form.errors.manuallyAssignedSupporters}</InputUI.Error>
          </Fieldset.Row>
        )}
    </>
  )
}
